import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/UI.css'
import uiHero from "../../../assets/images/ui-hero.jpg";
import uiDesign from "../../../assets/images/ui-hero.jpg";

const UIPage = () => {
  return (
    <div className="ui-container">
      <Helmet>
        <title>UI Design Services – BuddyTech Solutions</title>
        <meta name="description" content="Enhance user experience with intuitive and visually appealing UI design services tailored to your brand." />
        <meta name="keywords" content="UI design, interface design, web design, mobile UI, product interface, visual design" />

        <meta property="og:title" content="UI Design Services – BuddyTech Solutions" />
        <meta property="og:description" content="Enhance user experience with intuitive and visually appealing UI design services tailored to your brand." />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/ui" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="UI Design Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="Enhance user experience with intuitive and visually appealing UI design services tailored to your brand." />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>

      <header className="ui-hero">
        <div className="ui-hero-content">
          <h1>UI Design Services</h1>
          <p>
            We craft beautiful and user-friendly interfaces that captivate audiences and deliver seamless digital experiences.
          </p>
        </div>
        <img src={uiHero} alt="UI Hero" className="ui-hero-img" />
      </header>

      <section className="ui-section">
        <div className="ui-text">
          <h2>What We Deliver</h2>
          <p>
            From wireframes to final designs, we ensure that each interface is visually consistent, responsive, and optimized for performance.
          </p>
          <ul>
            <li>Web & Mobile UI Design</li>
            <li>Design Systems & Components</li>
            <li>Responsive Layouts</li>
            <li>Accessibility & UX Best Practices</li>
            <li>UI Prototyping & Handoff</li>
          </ul>
        </div>
        <img src={uiDesign} alt="UI Design" className="ui-img" />
      </section>

      <section className="ui-tools">
        <h2>Tools & Platforms</h2>
        <div className="tools-grid">
          <span>Figma</span>
          <span>Adobe XD</span>
          <span>Sketch</span>
          <span>InVision</span>
          <span>Zeplin</span>
          <span>Framer</span>
          <span>Canva</span>
          <span>Illustrator</span>
        </div>
      </section>
      <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
    </div>
  );
};

export default UIPage;
